export enum ArrowButtonType {
    INCREASE = 'plus',
    DECREASE = 'minus',
}

export enum ArrowButtonState {
    ENABLED = 'enabled',
    DISABLED = 'disabled',
    PRESSED = 'pressed',
    HOVER = 'hovered',
}

export enum FeatureGroup {
    BuyBonus = 1,
    ChancePlus = 2,
}
